export default __webpack_public_path__ + "arep_assstatus.html";